import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import Svg from '../../Svg'
import {HALF_STAR_START, HALF_STAR_END, EVENT_TYPE_ALL} from '../../../const'

import '../../../../scss/components/_review-stars.scss'
import halfStar from '../../../../../svg/half-star.svg'

// Anything > .75 would round up to a whole star
const isFullStar = (star, score) => {
  const float = score % 1
  return star <= score || (star > score && float > HALF_STAR_END)
}

// Anything from .25 to .75 would round up/down to a half star
const isHalfStar = (star, score) => {
  const float = score % 1
  return star > score && float > HALF_STAR_START && float < HALF_STAR_END
}

export const ProductStarRating = ({score}) => {
  const numberOfStars = [1, 2, 3, 4, 5]
  let result = null
  if (score !== EVENT_TYPE_ALL) {
    result = (
      <div className="product-star-rating">
        {numberOfStars.map((item) => {
          const starClasses = classNames('star-review-svg', {
            'is--full': isFullStar(item, score),
            'is--half': isHalfStar(item, score),
          })
          return <Svg key={item} className={starClasses} src={halfStar} />
        })}
      </div>
    )
  }
  return result
}

ProductStarRating.propTypes = {
  score: PropTypes.oneOfType([PropTypes.number.isRequired, PropTypes.string.isRequired]),
}

export default ProductStarRating
